export default __webpack_public_path__ + "static/media/CashbackOrange.8ede73e8.svg";